import React, { CSSProperties } from "react";
import { IETdState } from "./Interfaces";
import { ContainerEl } from "./index";
import * as Helpers from "./base/Helpers";

class ETd extends ContainerEl<HTMLTableCellElement, IETdState> {
    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
            padding: 0,
            margin: 0,
            border: 0,
            borderSpacing: 0,
            borderCollapse: "collapse",
        };

        if (this.props.Brand) {
            const { Brand } = this.props;

            styles = {
                backgroundColor: "transparent",
                padding: 0,
                margin: 0,
                border: 0,
                borderSpacing: 0,
                borderCollapse: "collapse",
                color: Brand.fontColor,
                fontFamily: Brand.fontFamily,
                fontSize: this.__unitSize(Brand.documentFontSize),
            };
        }

        if (this.props.color) {
            styles.color = this.props.color;
        }

        return styles;
    };

    render() {
        const { Brand, ...rest } = this.props;
        return (
            <td
                align={"left"}
                valign={"top"}
                style={this.__setStyle(this.getStyles())}
                {...rest}
            >
                {this.__passPropsToChildren({ Brand: Brand })}
            </td>
        );
    }
}

export { ETd };
